
import { createI18n } from 'vue-i18n'

// 1. carichiamo TUTTI i file di tutte le lingue (staticamente)
const modules = import.meta.glob('/src/locales/admin/**/*.json')

const i18n = createI18n({
    legacy         : false,
    locale         : 'it',
    fallbackLocale : 'en',
    messages       : {},
})

/**
 * Carica i file di una lingua specifica
 */
export const loadLocaleMessages = async (locale, fallbackLocale = 'en') => {
    const byLocale = {
        [fallbackLocale]: {},
        [locale]: {},
    }

    for (const path in modules) {

        // Esempio path: ./locales/it/auth.json
        const match = path.match(/\/locales\/admin\/([^\/]+)\/([^\/]+)\.json$/i)
        if (!match) continue

        const fileLocale = match[1]
        const section    = match[2]

        if (fileLocale !== locale && fileLocale !== fallbackLocale) continue

        const mod = await modules[path]()
        byLocale[fileLocale][section] = mod.default ?? mod
    }

    i18n.global.setLocaleMessage(fallbackLocale, byLocale[fallbackLocale])
    i18n.global.setLocaleMessage(locale, {
        ...byLocale[fallbackLocale],
        ...byLocale[locale],
    })
    i18n.global.locale.value = locale
}

export default i18n
